import React from 'react';
import PropTypes from 'prop-types';
import $j from 'jquery';
import 'jquery-inview';

class InView extends React.Component {
  static propTypes = {
    handle: PropTypes.func.isRequired,
    children: PropTypes.any.isRequired
  };

  rootRef = (element) => {
    if (element) {
      this.rootElement = element;
      $j(this.rootElement).on('inview', (e, isInView) => this.props.handle(isInView));
    } else {
      $j(this.rootElement).off('inview');
    }
  };

  render() {
    const { children } = this.props;

    return <div ref={this.rootRef}>{children}</div>;
  }
}

export default InView;
